module.exports = __webpack_public_path__ + "img/ic_prev_step.b242359b.svg";